import ImageDescriptor from './ImageDescriptor';

import './Art.css';

const Art = () => (
  <div id="Art">
		<h2>Art</h2>
    <fieldset>
      <legend>Pixel Art 👾</legend>
      <ImageDescriptor label="Sophie (Me!)" year="2023" src="art/me2.png">
        I wanted a new avatar for my Github account.
      </ImageDescriptor>
      <ImageDescriptor label="A cat paw" year="2023" src="art/catpaw.png">
        Just some toe beans~
      </ImageDescriptor>
      <ImageDescriptor label="A cactus" year="2022" src="art/cactus.png">
        Just doodling
      </ImageDescriptor>
      <ImageDescriptor label="A climbing cat" year="2024" src="art/cat.gif">
        I was considering making gamejam game with a cat, and so I wanted to see if I could animate a cat jumping up a ledge
      </ImageDescriptor>
      <ImageDescriptor label="A potted plant tipped over" year="2023" src="art/Tippedpot.gif">
        The cat was here
      </ImageDescriptor>
    </fieldset>
  </div>
);

export default Art;
